import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { WrappedApp } from './App';
import { initAnalytics } from './analytics';

initAnalytics();

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    tracePropagationTargets: [
      'localhost',
      import.meta.env.VITE_BACKEND_URL,
    ].filter(Boolean),
    enabled: import.meta.env.PROD,
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <WrappedApp />
);
